<template>
  <div class="hot-stocks">
    <sn-header text="热门个股" @change="onToggleStatusChange"></sn-header>
    <el-collapse-transition>
      <div class="conditions" v-if="conditionsShow">
        <hot-item v-for="(stock, index) in hotStocks" :key="index" :class="{'active': activeIndex === index}" :item="stock" @click.native="onItemClick(stock)"></hot-item>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import SnHeader from '@/components/common/SnHeader';
import HotItem from '@/components/common/HotItem';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      conditionsShow: true,
      activeIndex: -1,
      hotStocks: []
    };
  },
  methods: {
    onToggleStatusChange(res) {
      this.conditionsShow = res;
    },
    requestHotStocks() {
      this.hotStocks = [];
      QuestionQuery.hotStock().then(res => {
        this.hotStocks = res;
      });
    },
    onItemClick(res) {
      const params = {
        title: {
          include: res,
          exclude: ''
        },
        text: {
          include: '',
          exclude: ''
        },
        sortOrder: '',
        sortBy: '',
        pdfSize: {
          max: 0,
          min: 0
        },
        pageSize: 20,
        pageNum: 1,
        institution: [],
        industry: [],
        genre:[],
        date: {
          start: '',
          end: ''
        },
        category: []
      };
      this.$emit('mySearchCondition', params);
    }
  },
  components: {
    SnHeader,
    HotItem
  },
  mounted() {
    this.requestHotStocks();
  }
};
</script>
<style lang="scss" scoped>
.hot-stocks {
  .conditions {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    padding: 16px;
    background-color: #ffffff;
    .active {
      color: #0750E0;
      font-weight: bold;
    }
  }
}
</style>
